import { render, staticRenderFns } from "./IsometricScalingIcon.vue?vue&type=template&id=b7e48532&"
import script from "./IsometricScalingIcon.vue?vue&type=script&lang=js&"
export * from "./IsometricScalingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports